import { useComponentVariant } from '@/hooks/theme/useComponentVariant';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import dynamic from 'next/dynamic';

const RollPointGameButtonV1 = dynamic(() => import('./V1'), { ssr: true });
const RollPointGameButtonV2 = dynamic(() => import('./V2'), { ssr: true });

export default function RollPointGameButton() {
  const version: string = useComponentVariant(ComponentTypeId.RollPointGame);

  switch (process.env.NEXT_PUBLIC_TENANT_ID) {
    case 'ice':
      return <RollPointGameButtonV1 />;
    case 'kube':
      return <RollPointGameButtonV2 />;
    default:
      return <RollPointGameButtonV1 />;
  }
}
